import { GetInvestorValuationsRes } from '@dealstack/shared/lib/generated';

type ValuationsPayload = Pick<GetInvestorValuationsRes, 'valuations' | 'loans'>;

export interface HoldingsTotals {
	totalValue: number;
	totalCost: number;
	totalLoanValue: number;
}

const sum = (values: number[]) => values.reduce((total, value) => total + value, 0);

/**
 * Aggregates the valuations payload into the three figures the summary card shows. The
 * endpoint already covers holdings held via an investment vehicle, so no extra work here.
 * Both loan definition types count towards the loan figure, per the ticket's "Total Loan Value".
 */
export const getHoldingsTotals = (data: ValuationsPayload | undefined): HoldingsTotals => {
	const valuations = data?.valuations ?? [];
	const loans = data?.loans ?? [];

	return {
		totalValue: sum(valuations.map(({ value }) => value ?? 0)),
		totalCost: sum(valuations.map(({ cost }) => cost)),
		totalLoanValue: sum(loans.map(({ totalValue }) => totalValue)),
	};
};
